import { ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface FormGridLayoutProps {
    children: ReactNode;
    sx?: SxProps<Theme>;
}

const FormGridLayout = ({ children, sx }: FormGridLayoutProps) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                rowGap: 1,
                columnGap: 2.5,
                ...(sx as object),
            }}
        >
            {children}
        </Box>
    );
};

export default FormGridLayout;
